import * as Icons from "grommet-icons"

const shortcodes = { ...Icons }

export default shortcodes
